// src/index.js or src/main.js (entry point)
import React from 'react';
import { createRoot } from 'react-dom/client'; // React 18+
import App from './App';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import store from './utils/Redux/Store/Store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const queryClient = new QueryClient(); // **create instance once**

const persistor = persistStore(store);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}> {/* <-- pass client here */}
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <App />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);



// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import { Provider } from 'react-redux';
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query'; // <-- import QueryClient
// import store from './utils/Redux/Store/Store';
// import { PersistGate } from 'redux-persist/integration/react';
// import { persistStore } from 'redux-persist';

// const queryClient = new QueryClient(); // <-- create QueryClient instance
// const persistor = persistStore(store);

// ReactDOM.render(
//   <QueryClientProvider client={queryClient}> {/* <-- pass client here */}
//     <Provider store={store}>
//       <PersistGate persistor={persistor}>
//         <App />
//       </PersistGate>
//     </Provider>
//   </QueryClientProvider>,
//   document.getElementById('root')
// );


